import { render } from "./DashboardCommunityDataCard.vue?vue&type=template&id=c7eb1f8c"
import script from "./DashboardCommunityDataCard.vue?vue&type=script&lang=js"
export * from "./DashboardCommunityDataCard.vue?vue&type=script&lang=js"

import "./DashboardCommunityDataCard.vue?vue&type=style&index=0&id=c7eb1f8c&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "c7eb1f8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7eb1f8c', script)) {
    api.reload('c7eb1f8c', script)
  }
  
  module.hot.accept("./DashboardCommunityDataCard.vue?vue&type=template&id=c7eb1f8c", () => {
    api.rerender('c7eb1f8c', render)
  })

}

script.__file = "src/components/dashboard/DashboardCommunityDataCard.vue"

export default script